module.exports = __webpack_public_path__ + "img/Guinea.8ec3de32.gif";